import { useFeatureFlags } from '@eventbrite/feature-flag-utils';
import React, { useContext, useState } from 'react';
import { logEventClickFromSearch } from './requests';
import { SearchRetrievalContext } from './types';

const defaultRetrievalContext: SearchRetrievalContext = {
    date_filter: null,
    query_terms: null,
    is_online: null,
    place_id: null,
    latitude: null,
    longitude: null,
    search_id: null,
};

const RetrievalContext = React.createContext({
    retrievalContext: defaultRetrievalContext,
    shouldUseSDK: true,
    eventClickTracker: (
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        id: string,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        position: number,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        adId?: string,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        placementId?: string,
    ) => {
        // noop, will be replaced in context when app initializes
    },
});

export function SearchRetrievalContextProvider(props: {
    // TODO eventSearch type
    eventSearch: any;
    searchId: string;
    children: React.ReactNode;
}) {
    // Note: Use state here due to: https://reactjs.org/docs/context.html#caveats
    const [retrievalContext] = useState({
        date_filter: props.eventSearch.dates || null,
        query_terms: props.eventSearch.q || null,
        is_online: props.eventSearch.onlineEventsOnly,
        place_id: Array.isArray(props.eventSearch.places)
            ? props.eventSearch.places[0]
            : null,
        latitude: null,
        longitude: null,
        search_id: props.searchId,
    });

    const { useNewEventInteractionsTrackingSystem } = useFeatureFlags();

    return (
        <RetrievalContext.Provider
            value={{
                retrievalContext,
                shouldUseSDK: true,
                eventClickTracker: (id, position, adId, placementId) => {
                    !useNewEventInteractionsTrackingSystem &&
                        logEventClickFromSearch(
                            id,
                            position,
                            retrievalContext,
                            adId,
                            placementId,
                        );
                },
            }}
        >
            {props.children}
        </RetrievalContext.Provider>
    );
}

export function useSearchRetrievalContext() {
    const searchRetrievalContext = useContext(RetrievalContext);

    return searchRetrievalContext;
}

export function useEventClickTracker() {
    const searchRetrievalContext = useContext(RetrievalContext);

    return searchRetrievalContext.eventClickTracker;
}
